declare namespace $ {

	export class $mol_icon_clipboard_text extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=text.view.tree.d.ts.map